var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrying(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M9.44764 26.1334C9.20384 25.9734 8.89144 25.9505 8.6324 26.0876C8.6324 26.0876 8.6324 26.0876 8.6248 26.0876C7.46668 26.6819 7.33716 25.2343 6.27052 25.5467C5.31052 25.8286 3.18479 26.5448 4.13716 27.2076C4.86096 27.7181 5.69908 27.1543 6.2324 27.4667C7.26096 28.061 7.20004 28.2438 8.0686 27.9619C9.72192 27.421 9.3562 28.0534 10.5448 28.2743C11.4058 28.4343 12.4267 28.1448 12.9067 27.6572C11.6724 27.3295 10.5067 26.8114 9.44764 26.1334Z",
    fill: "url(#paint0_linear_179_9025)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07432 25.8821C8.92952 25.9431 8.78476 26.0116 8.62476 26.0878C7.46668 26.6821 7.38288 25.5469 6.27048 25.5469C5.24192 25.5469 3.18477 26.545 4.13716 27.2078C4.86096 27.7183 5.69908 27.1545 6.2324 27.4669C7.26096 28.0612 7.2 28.244 8.0686 27.9621C9.72192 27.4212 9.3562 28.0536 10.5448 28.2745C11.4057 28.4345 12.4267 28.145 12.9067 27.6574C11.52 27.2916 10.2248 26.6821 9.07432 25.8821Z",
    fill: "url(#paint1_linear_179_9025)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 28.0382C22.7327 28.0382 28.1905 22.5803 28.1905 15.8477C28.1905 9.11509 22.7327 3.65723 16.0001 3.65723C9.26745 3.65723 3.80957 9.11509 3.80957 15.8477C3.80957 22.5803 9.26745 28.0382 16.0001 28.0382Z",
    fill: "url(#paint2_radial_179_9025)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.1904 15.8477C28.1904 22.5829 22.7352 28.0001 15.9999 28.0382C9.31042 28.0686 3.83993 22.6058 3.80945 15.8477C3.77898 9.11245 9.2647 3.65723 15.9999 3.65723C22.7352 3.65723 28.1904 9.11245 28.1904 15.8477Z",
    fill: "url(#paint3_radial_179_9025)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9392 13.737C12.343 13.3331 10.2173 13.4931 9.24971 14.1255C8.74683 14.4531 6.81159 14.6817 7.78683 24.8608C8.84587 25.836 10.0802 26.6207 11.4287 27.1693C8.46495 20.0607 11.3602 14.316 11.9392 13.737Z",
    fill: "url(#paint4_linear_179_9025)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8916 24.5564C14.3011 24.046 15.0173 23.7108 16.0001 23.7108C16.983 23.7108 17.7068 24.046 19.1087 24.5564C20.4192 25.0288 21.1506 24.046 21.0059 22.6136C20.4954 19.5964 18.3011 17.2803 16.0001 17.2803C13.7678 17.2803 11.6344 19.4136 11.0401 22.2784C10.7354 23.886 11.4821 25.0593 12.8916 24.5564Z",
    fill: "url(#paint5_radial_179_9025)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5409 20.9755C19.6495 18.7964 17.859 17.2803 15.9999 17.2803C14.1409 17.2803 12.3504 18.7964 11.459 20.9755C11.4818 20.9298 12.0533 19.7412 13.2342 19.9926C14.438 20.2517 15.9999 20.2822 15.9999 20.2822C15.9999 20.2822 17.5542 20.2441 18.7657 19.9926C19.9771 19.7412 20.5409 20.9755 20.5409 20.9755Z",
    fill: "url(#paint6_linear_179_9025)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 19.5429C16.9904 19.5429 17.9809 19.4972 18.9637 19.3981C18.8723 19.2915 18.7809 19.1924 18.6819 19.0934C17.8742 18.2781 16.9219 17.8286 15.9999 17.8286C15.078 17.8286 14.1257 18.2781 13.318 19.0934C13.219 19.1924 13.1275 19.2915 13.0361 19.3981C14.019 19.4972 15.0095 19.5429 15.9999 19.5429Z",
    fill: "url(#paint7_radial_179_9025)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.7754C14.5753 21.7754 12.5639 22.3849 12.0991 24.1982C12.442 24.0992 12.8458 23.9392 13.1429 23.8249C14.0344 23.482 15.04 23.162 15.9924 23.162C16.9448 23.162 17.9505 23.5506 18.842 23.9011C19.1391 24.0154 19.5505 24.1754 19.8934 24.2744C19.4439 22.423 17.4248 21.7754 16 21.7754Z",
    fill: "url(#paint8_radial_179_9025)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50297 10.1102C8.53345 10.5979 9.07441 10.8721 9.98105 10.8264C10.7506 10.7807 12.4192 10.2626 13.501 8.7007C13.6992 8.41118 13.3639 8.28166 13.1582 8.47214C12.4725 9.11974 10.5982 10.0112 9.08965 9.92738C8.48773 9.8969 8.50297 10.1102 8.50297 10.1102Z",
    fill: "url(#paint9_linear_179_9025)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1923 12.2361C11.1923 12.2361 13.3942 12.1218 14.2628 13.5466C14.3161 13.638 14.3542 13.737 14.3695 13.8361C14.4 14.0418 14.24 14.278 13.8209 14.1408C11.2304 13.2799 9.90473 13.9123 8.89901 14.3694C8.51045 14.5446 8.07613 14.1713 8.22089 13.8513C8.93709 12.2361 11.1923 12.2361 11.1923 12.2361Z",
    fill: "url(#paint10_radial_179_9025)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1923 12.2361C11.1923 12.2361 13.3942 12.1218 14.2628 13.5466C14.2932 13.5999 14.3237 13.6532 14.339 13.7142C13.0285 12.6246 11.2304 12.7237 11.2304 12.7237C11.2304 12.7237 9.55421 12.6323 8.30469 13.6837C9.09705 12.2361 11.1923 12.2361 11.1923 12.2361Z",
    fill: "url(#paint11_linear_179_9025)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4972 10.1102C23.4667 10.5979 22.9258 10.8721 22.0191 10.8264C21.2496 10.7807 19.581 10.2626 18.4991 8.7007C18.301 8.41118 18.6363 8.28166 18.842 8.47214C19.5277 9.11974 21.402 10.0112 22.9106 9.92738C23.5125 9.8969 23.4972 10.1102 23.4972 10.1102Z",
    fill: "url(#paint12_linear_179_9025)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8077 12.2361C20.8077 12.2361 18.6058 12.1218 17.7373 13.5466C17.6839 13.638 17.6458 13.737 17.6306 13.8361C17.6001 14.0418 17.7601 14.278 18.1791 14.1408C20.7696 13.2799 22.0953 13.9123 23.1011 14.3694C23.4896 14.5446 23.9239 14.1713 23.7791 13.8513C23.063 12.2361 20.8077 12.2361 20.8077 12.2361Z",
    fill: "url(#paint13_radial_179_9025)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8076 12.2361C20.8076 12.2361 18.6056 12.1218 17.7371 13.5466C17.7066 13.5999 17.6761 13.6532 17.6609 13.7142C18.9714 12.6246 20.7695 12.7237 20.7695 12.7237C20.7695 12.7237 22.4456 12.6323 23.6952 13.6837C22.9028 12.2361 20.8076 12.2361 20.8076 12.2361Z",
    fill: "url(#paint14_linear_179_9025)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98677 27.2231C6.41537 14.2707 8.65537 14.2098 9.22677 13.905C10.2401 13.3564 12.0154 13.1659 11.9392 13.7374C11.8554 14.3774 8.51061 14.9945 9.99629 27.2231",
    fill: "url(#paint15_linear_179_9025)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M9.44755 26.1332C9.20375 25.9732 8.89135 25.9504 8.63231 26.0875C8.63231 26.0875 8.63231 26.0875 8.62471 26.0875C7.46659 26.6818 7.38279 25.5618 6.27043 25.5466C5.31803 25.5313 3.1847 26.5446 4.13707 27.2075C4.86091 27.718 5.69899 27.1542 6.23231 27.4666C7.26091 28.0608 7.19995 28.2437 8.06851 27.9618C9.72183 27.4208 9.35615 28.0532 10.5447 28.2742C11.4057 28.4342 12.4266 28.1446 12.9066 27.657C11.6723 27.3294 10.5066 26.8113 9.44755 26.1332Z",
    fill: "url(#paint16_linear_179_9025)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M6.98677 27.2231C6.41537 14.2707 8.65537 14.2098 9.22677 13.905C10.2401 13.3564 12.0154 13.1659 11.9392 13.7374C11.8554 14.3774 8.51061 14.9945 9.99629 27.2231",
    fill: "url(#paint17_linear_179_9025)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M6.98677 27.2231C6.41537 14.2707 8.65537 14.2098 9.22677 13.905C10.2401 13.3564 12.0154 13.1659 11.9392 13.7374C11.8554 14.3774 8.51061 14.9945 9.99629 27.2231",
    fill: "url(#paint18_linear_179_9025)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98677 27.2231C6.41537 14.2707 8.65537 14.2098 9.22677 13.905C10.2401 13.3564 12.0154 13.1659 11.9392 13.7374C11.8554 14.3774 8.51061 14.9945 9.99629 27.2231",
    fill: "url(#paint19_linear_179_9025)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M22.5525 26.1334C22.7964 25.9734 23.1087 25.9505 23.3678 26.0876C23.3678 26.0876 23.3678 26.0876 23.3754 26.0876C24.5335 26.6819 24.663 25.2343 25.7297 25.5467C26.6897 25.8286 28.8154 26.5448 27.863 27.2076C27.1392 27.7181 26.3011 27.1543 25.7678 27.4667C24.7392 28.061 24.8002 28.2438 23.9316 27.9619C22.2783 27.421 22.644 28.0534 21.4554 28.2743C20.5945 28.4343 19.5735 28.1448 19.0935 27.6572C20.3278 27.3295 21.4935 26.8114 22.5525 26.1334Z",
    fill: "url(#paint20_linear_179_9025)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9259 25.8821C23.0707 25.9431 23.2154 26.0116 23.3754 26.0878C24.5335 26.6821 24.6173 25.5469 25.7297 25.5469C26.7583 25.5469 28.8154 26.545 27.863 27.2078C27.1392 27.7183 26.3011 27.1545 25.7678 27.4669C24.7392 28.0612 24.8002 28.244 23.9316 27.9621C22.2783 27.4212 22.644 28.0536 21.4554 28.2745C20.5945 28.4345 19.5735 28.145 19.0935 27.6574C20.4802 27.2916 21.7754 26.6821 22.9259 25.8821Z",
    fill: "url(#paint21_linear_179_9025)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0609 13.737C19.6571 13.3331 21.7828 13.4931 22.7504 14.1255C23.2533 14.4531 25.1885 14.6817 24.2133 24.8608C23.1542 25.836 21.9199 26.6207 20.5714 27.1693C23.5352 20.0607 20.6399 14.316 20.0609 13.737Z",
    fill: "url(#paint22_linear_179_9025)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0134 27.2231C25.5848 14.2707 23.3448 14.2098 22.7734 13.905C21.76 13.3564 19.9848 13.1659 20.061 13.7374C20.1448 14.3774 23.4896 14.9945 22.0038 27.2231",
    fill: "url(#paint23_linear_179_9025)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M22.5525 26.1332C22.7964 25.9732 23.1087 25.9504 23.3678 26.0875C23.3678 26.0875 23.3678 26.0875 23.3754 26.0875C24.5335 26.6818 24.6173 25.5618 25.7297 25.5466C26.6821 25.5313 28.8154 26.5446 27.863 27.2075C27.1392 27.718 26.3011 27.1542 25.7678 27.4666C24.7392 28.0608 24.8002 28.2437 23.9316 27.9618C22.2783 27.4208 22.644 28.0532 21.4554 28.2742C20.5945 28.4342 19.5735 28.1446 19.0935 27.657C20.3278 27.3294 21.4935 26.8113 22.5525 26.1332Z",
    fill: "url(#paint24_linear_179_9025)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M25.0134 27.2231C25.5848 14.2707 23.3448 14.2098 22.7734 13.905C21.76 13.3564 19.9848 13.1659 20.061 13.7374C20.1448 14.3774 23.4896 14.9945 22.0038 27.2231",
    fill: "url(#paint25_linear_179_9025)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M25.0134 27.2231C25.5848 14.2707 23.3448 14.2098 22.7734 13.905C21.76 13.3564 19.9848 13.1659 20.061 13.7374C20.1448 14.3774 23.4896 14.9945 22.0038 27.2231",
    fill: "url(#paint26_linear_179_9025)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0134 27.2231C25.5848 14.2707 23.3448 14.2098 22.7734 13.905C21.76 13.3564 19.9848 13.1659 20.061 13.7374C20.1448 14.3774 23.4896 14.9945 22.0038 27.2231",
    fill: "url(#paint27_linear_179_9025)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.1904 15.8477C28.1904 22.5829 22.7352 28.0001 15.9999 28.0382C9.31042 28.0686 3.83993 22.6058 3.80945 15.8477C3.77898 9.11245 9.2647 3.65723 15.9999 3.65723C22.7352 3.65723 28.1904 9.11245 28.1904 15.8477Z",
    fill: "url(#paint28_radial_179_9025)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_179_9025",
    x1: 11.3425,
    y1: 26.9384,
    x2: 7.62372,
    y2: 26.8925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_179_9025",
    x1: 8.18188,
    y1: 25.1961,
    x2: 8.38972,
    y2: 27.1147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8656,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_179_9025",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6017 10.9073) scale(14.7062 14.7062)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_179_9025",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6015 10.9074) scale(11.5701 11.5701)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_179_9025",
    x1: 14.8445,
    y1: 20.4704,
    x2: 4.10519,
    y2: 20.0368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_179_9025",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5775 21.0473) scale(3.24773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_179_9025",
    x1: 11.4609,
    y1: 19.1256,
    x2: 20.5401,
    y2: 19.1256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_179_9025",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9064 18.853) scale(3.20671 3.20671)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9BCBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_179_9025",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0014 22.765) scale(3.46505 0.88332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C20000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_179_9025",
    x1: 11.0832,
    y1: 11.4365,
    x2: 11.0452,
    y2: 9.77302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_179_9025",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.2322 13.2756) rotate(-2.88189) scale(2.35651 1.04712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_179_9025",
    x1: 11.3203,
    y1: 10.6783,
    x2: 11.3203,
    y2: 13.7446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_179_9025",
    x1: 20.9171,
    y1: 11.4365,
    x2: 20.9552,
    y2: 9.77302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_179_9025",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.766 13.2757) rotate(-177.118) scale(2.35651 1.04712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_179_9025",
    x1: 20.6797,
    y1: 10.6783,
    x2: 20.6797,
    y2: 13.7446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_179_9025",
    x1: 8.41889,
    y1: 8.91524,
    x2: 10.1754,
    y2: 28.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3331,
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4126,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5715,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#17BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8891,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_179_9025",
    x1: 10.1187,
    y1: 27.855,
    x2: 6.88063,
    y2: 26.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_179_9025",
    x1: 10.157,
    y1: 14.907,
    x2: 8.73477,
    y2: 21.8658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_179_9025",
    x1: 9.63865,
    y1: 23.113,
    x2: 9.86721,
    y2: 26.6177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_179_9025",
    x1: 9.41921,
    y1: 24.8085,
    x2: 9.41921,
    y2: 12.5164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17BBFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0099D6",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_179_9025",
    x1: 20.658,
    y1: 26.9385,
    x2: 24.3767,
    y2: 26.8926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_179_9025",
    x1: 23.8186,
    y1: 25.1962,
    x2: 23.6107,
    y2: 27.1147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8656,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_179_9025",
    x1: 17.1559,
    y1: 20.4704,
    x2: 27.8952,
    y2: 20.0368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_179_9025",
    x1: 23.5815,
    y1: 8.91528,
    x2: 21.825,
    y2: 28.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3331,
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4126,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5715,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#17BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8891,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_179_9025",
    x1: 21.8817,
    y1: 27.855,
    x2: 25.1197,
    y2: 26.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_179_9025",
    x1: 21.8434,
    y1: 14.907,
    x2: 23.2657,
    y2: 21.8658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_179_9025",
    x1: 22.3618,
    y1: 23.113,
    x2: 22.1332,
    y2: 26.6177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_179_9025",
    x1: 22.5812,
    y1: 24.8085,
    x2: 22.5812,
    y2: 12.5165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17BBFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0099D6",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_179_9025",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1049 25.7826) rotate(-90) scale(1.6254 5.0782)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3541E",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#B26126",
    stopOpacity: 0.3578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8286,
    stopColor: "#DA843C",
    stopOpacity: 0.0836319
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#E89043",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrying);
export default __webpack_public_path__ + "static/media/crying.e4fb178a8c7f9bdb89e9dc8ec51009c4.svg";
export { ForwardRef as ReactComponent };